import * as sass from "sass"

/**
 * Converts SCSS content to CSS
 * @param scssContent The SCSS content to convert
 * @returns The compiled CSS content
 */
export async function transformScssToCSS(scssContent: string): Promise<string> {
  try {
    const result = sass.compileString(scssContent, {
      style: "expanded",
    })
    return result.css
  } catch (error) {
    throw new Error(
      `Failed to compile SCSS to CSS: ${error instanceof Error ? error.message : String(error)}`
    )
  }
}
